export default __webpack_public_path__ + "static/SportSupport_logo-fe238c306e3cce6978e9cec687617e82.png";